<script setup lang="ts">
import FormScaffold from '@legacy/components/common/form/FormScaffold.vue';
import ChildAvatarsRepository from '@legacy/js/repository/ChildAvatarsRepository';
import { ref } from 'vue';
import { useNotifications } from '@/composables/notifications';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = withDefaults(defineProps<Props>(), {});

const { notify } = useNotifications();

interface Props {
    id: number
    sets: {
        label: string
        value: string
    }[]
    childAvatarSet: string
}

const selected = ref(props.childAvatarSet);
const pending = ref(false);

function save() {
    if (pending.value) {
        return;
    }

    pending.value = true;
    ChildAvatarsRepository.update(props.id, { childAvatarSet: selected.value })
        .then(() => {
            notify.success('saveChanges.success');
        })
        .catch(() => {
            notify.error('saveChanges.error');
        })
        .finally(() => pending.value = false);
}
</script>

<template>
    <FormScaffold
        :hide-mandatory-fields-hint="true"
        :with-back-button="false"
        :with-primary-buttons="true"
        :loading="pending"
        @primary-btn-clicked="save"
    >
        <div class="flex flex-col gap-4">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('Standardbilder für Kinderprofile') }}
            </h3>
            <p class="text-muted-foreground">
            </p>
            <div class="flex flex-col">
                <label
                    v-for="option in sets"
                    :key="option.value"
                    class="kgr-radio kgr-radio--region kgr-region--default kgr-row"
                >
                    <input
                        type="radio"
                        :value="option.value"
                        :checked="option.value === props.childAvatarSet"
                        name="childAvatarSet"
                        class="kgr-radio__control"
                        @change="selected = option.value"
                    />

                    <div class="kgr-radio__label kgr-postfix kgr-postfix--bigGutters kgr-postfix--center">
                        <span class="kgr-headline kgr-headline--h5 flex-none w-28">{{ $t(option.label) }}</span>

                        <div
                            v-for="type of ['default-boy', 'default-girl', 'default']"
                            :key="type"
                            class="kgr-profileImage kgr-profileImage--inline kgr-profileImage--sizeM flex-none"
                            style="--kgr-profileImage-size:7rem;"
                        >
                            <img
                                class="kgr-profileImage__image"
                                :src="`/img/avatar/child/${option.value}/${type}.png`"
                                alt=""
                            />
                        </div>
                    </div>
                </label>
            </div>
        </div>
    </FormScaffold>
</template>
